import meetingService from "@/apis/meeting/index.js";

export default {
  data() {
    return {
      meetingRoomsList: [],
    };
  },
  created() {
    this.getMeetingRooms();
  },
  methods: {
    getMeetingRooms() {
      return meetingService.getMeetingRooms().then((res) => {
        res.forEach((item) => {
          item.value = item.room_id;
          item.text = item.room_name;
        });
        this.meetingRoomsList = res;
        return true;
      });
    },
    async getRoomInfoById(id) {
      if (this.meetingRoomsList.length === 0) {
        await this.getMeetingRooms();
      }
      return this.meetingRoomsList.find((item) => item.room_id == id);
    },
  },
};
